import { Component, OnInit } from '@angular/core';
import { ParametersService } from '../service/parameters.service';
import { Settings, ApiWebHook } from '../model/settings.model';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import 'parse';
const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.less']
})
export class ParametersComponent implements OnInit {
  currentSection = 'parameters-user';
  settings: Settings;
  username: string;
  isSuperAdmin = false;

  constructor(private readonly _parametersService: ParametersService,
    private readonly _auth: AuthService,
    private readonly _router: Router) {
    this.isSuperAdmin = this._parametersService.isSuperAdmin
  }


  logout() {
    this._auth
      .logout()
      .subscribe(result => this._router.navigate(['/user/signin']));
    window.location.reload();
  }

  ngOnInit() {
    this.settings = this._parametersService.getAll(true);
    this.username = parse.User.current().get('username');
    this.showMobileScrollSpy(window.innerWidth);
    $(window).on('resize', () => {
      this.showMobileScrollSpy(window.innerWidth);
    });
  }

  showMobileScrollSpy(width: number) {
    $(window).on('scroll', () => {
      if (width < 992 && $(window).scrollTop() > 154) {
        $('#parameters-header').removeClass('hide-out');
        $('#parameters-header').addClass('show-in');
      } else if ($('#parameters-header').hasClass('show-in')) {
        $('#parameters-header').addClass('hide-out');
        $('#parameters-header').removeClass('show-in');
      }
    });
    if (width > 992 && $('#parameters-header').hasClass('show-in')) {
      $('#parameters-header').addClass('hide-out');
      $('#parameters-header').removeClass('show-in');
    }
  }

  onSectionChange(sectionId: string) {
    // console.log('Section change: ', sectionId);
    this.currentSection = sectionId;
  }


}



// WEBPACK FOOTER //
// ./src/app/parameters/parameters.component.ts